import DataGrid, { Column, Grouping, GroupPanel, Pager, Paging, SearchPanel, FilterRow,GroupItem,Summary } from 'devextreme-react/data-grid';
import { TonKhoAVPSelector, getTonKhoBatch } from '../../store/reducers/Report/TonKhoAVP'
import { AuthSelector } from '../../store/reducers/auth/auth'
import { MasterDataSelector } from '../../store/reducers/masterData/masterData'
import { useSelector, useDispatch } from 'react-redux'
import 'devextreme/dist/css/dx.light.css';
import React, { useState, useContext, useEffect } from 'react';
import { Spin } from 'antd';
import moment from 'moment';

const pageSizes = [10, 20, 50, 100, 500];

function TonKhoAVP() {
    const dispatch = useDispatch()
    const TonKhoAVPSelectors = useSelector(TonKhoAVPSelector)
    const UserSelectors = useSelector(AuthSelector)
    const MasterDataSelectors = useSelector(MasterDataSelector)
    const authWhs = MasterDataSelectors.authWhs.map(function(Whs){
        return Whs.Code;
    }).join(",")
    console.log((moment(Date.now())).format('yyyy/MM/DD'))
    const [loadParam, setLoadParam] = useState({
        FrDate: (moment(Date.now())).format('yyyy/MM/DD'),
        ToDate: (moment(Date.now())).format('yyyy/MM/DD'),
        FrItem: "",
        ToItem: "",
        BchID: "",
        WhsID: authWhs,
        BrdID: "",
        GrpID: "",
        S1GrpID: "",
        View: "",
        UserID: UserSelectors.user.userId,
        SeriType: "0",
        Vendor: ""
    })
    useEffect(() => {
        dispatch(getTonKhoBatch(loadParam))
    }, [])
    return (
        <>
            <Spin tip="Loading..." spinning={TonKhoAVPSelectors.Loading}>
                <div className="dx-viewport"  style={{backgroundColor: 'white', padding: '10px'}}>
                    <DataGrid dataSource={TonKhoAVPSelectors.TonKhoBatch}
                        allowColumnReordering={true}
                        rowAlternationEnabled={true}
                        showBorders={true}
                        columnAutoWidth={true}>
                        <FilterRow visible={true} />
                        <GroupPanel visible={true} />
                        <SearchPanel visible={true} highlightCaseSensitive={true} width={200} />
                        <Grouping autoExpandAll={true} />
                        <Column dataField="ItemCode" caption={"Mã hàng"} dataType="string" groupIndex={0} />
                        <Column dataField="ItemName" caption={"Tên hàng"} dataType="string" />
                        <Column dataField="WhsName" caption={"Tên kho"} dataType="string" groupIndex={0} />
                        <Column dataField="DistNumber" caption={"Số lô/Serial"} dataType="string" />
                        <Column dataField="Quantity" caption={"Số lượng"} dataType="number" format={"#,###,###.####"} />
                        <Column dataField="U_Qty1" caption={"Cuộn nguyên"} dataType="number" format={"#,###,###.####"} />
                        <Column dataField="CuonDo" caption={"Cuộn dở"} dataType="string" />
                        <Column dataField="InDate" caption={"Ngày nhập"} dataType="date" format={"dd/MM/yyyy"} />
                        <Column dataField="DaysNum" caption={"Ngày tồn kho"} dataType="number" format={"#,###,###"} />
                        <Column dataField="QCChieuDai" caption={"Chiều dài"} dataType="number" format={"#,###,###.####"} />
                        <Column dataField="U_Seal" caption={"Số Seal"} dataType="string" />
                        <Column dataField="SalUnitMsr" caption={"ĐVT bán"} dataType="string" />
                        <Column dataField="InvntryUom" caption={"ĐVT tồn kho"} dataType="string" />
                        <Column dataField="U_Pro_2" caption={"U_Pro_2"} dataType="string" />
                        <Column dataField="U_Cont" caption={"Số cont"} dataType="string" />
                        <Column dataField="ChungNhan" caption={"Chứng nhận"} dataType="string" />
                        <Column dataField="U_Pro_4" caption={"U_Pro_4"} dataType="string" />
                        <Column dataField="BuyUnitMsr" caption={"ĐVT mua"} dataType="string" />
                        <Column dataField="U_Pro_5" caption={"U_Pro_5"} dataType="string" />
                        <Column dataField="U_Pro_6" caption={"U_Pro_6"} dataType="string" />
                        <Column dataField="FirmName" caption={"Hãng sản xuất"} dataType="string" />
                        <Column dataField="TinhChat" caption={"Tính chất"} dataType="string" />
                        <Column dataField="ItmsGrpNam" caption={"Nhóm hàng"} dataType="string" />
                        <Column dataField="DangHang" caption={"Dạng hàng"} dataType="string" />
                        <Column dataField="QC" caption={"QC"} dataType="string" />

                        <Summary>
                            <GroupItem
                                column="Quantity"
                                summaryType="sum"
                                valueFormat="###,###,###.###"
                                showInGroupFooter={false}
                                alignByColumn={true} />
                        </Summary>

                        <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
                        <Paging defaultPageSize={10} />
                    </DataGrid>
                </div>
            </Spin>
        </>
    );
}

export default TonKhoAVP;